import { upperCase } from "lodash"

export const defaultStyle = {
  wrapperFullBg: "wrapperFullBg tableIcon",
  wrapper: "relative tableIconWrapper",
  imgTxtContainer: "test3 flex flex-wrap lg:flex-nowrap items-center justify-between max-w-full pb-16 my-0 mx-auto absolute top-[50%] translate-y-[-50%]   pr-[40px] zMinus",
  imgWrapper: "imgWrapper lg:mr-[20px] lg:my-auto mx-auto mt-0 mb-10",
  textImg: "w-full ",
  textContent: "text-lg leading-7 text-center w-[354px] m-w-[354px] text-[#7f7f7f] mx-auto my-auto",
  textHead: "text-[#00358e] font-bold	mx-auto",
  textDesc: "",
  textLink: "",
  imgBtn: "",
}
export const COL6_6_WITH_BAGE_IMAGE = { //used in /Japan/News-Releases/OREO-110th-birthday/ page
  ...defaultStyle,
  imgTxtContainer: "imageTextContainerForOreoJapan",  
}

export const ONLY_PAGE_IMAGE = {
  imgTxtContainer: "",
  imgWrapper: "mb-30px md:mb-[50px] [&>img]:!w-[auto] [&>img]:mx-auto px-[35px]"
}
export const QUOTE_CONTAINER = {
  imgTxtContainer:
    "lg:flex flex-wrap lg:flex-nowrap lg:bg-transparent bg-darkBlue items-center rounded-[20px]  justify-between max-w-full my-0 mx-auto relative",
  wrapper:
    "wrapper lg:max-w-full lg:w-[1170px] lg:mx-auto mx-10 md:mx-30 md:mt-80 mt-30",
  imgWrapper:
    "QUOTE_CONTAINER lg:mx-[15px] lg:my-auto mx-auto mt-0 mb-10 md:mb-0 w-full flex",
  textImg:
    "lg:rounded-[20px] w-full lg:h-full lg:scale-[1] md:scale-[1.5] relative lg:static left-[-50%] md:left-[-25%] lg:left[auto] scale-[2] top-[23%] md:top-[15%] lg:top-[0]",
  textContent:
    "my-0 mx-auto px-0 py-8 relative text-white w-full bg-darkBlue lg:bg-transparent lg:absolute lg:text-white lg:width-1/2 lg:top-[15%] lg:left-[10%] text-3xl lg:w-[400px] lg:text-left text-center",
  textHead: "",
  textDesc:
    "text-white md:text-[30px] text-[21px] lg:w-[319px] md:leading-[33px] lg:h-auto px-[12px] md:px-[0] h-[260px] leading-[26px] text-center lg:text-left lg:ml-[133px] lg:mb-20",
  textLink: "textLink",
  imgBtn: "",
  subimgWrpr:
    " rounded-t-[20px] overflow-hidden h-[388px] md:h-[600px] lg:h-auto lg:min-h-[600px]",
  textWrpr:
    "lg:absolute lg:top-[100px] z-[2] md:w-[500px] md:mx-auto md:pb-10 md:pt-0 pb-0 ",
  gradBg:
    "lg:bg-gradBgLetToRigth  absolute w-[700px] lg:h-full rounded-l-[20px] z-[1]",
}

export const TEXT_LISTING = {
  textWrpr:
    "textWrpr lg:w-[1170px] lg:mx-auto mx-15 lg:mt-70 lg:mb-50 mt-20 max-w-full",
  textHead:
    "textHead lg:text-[40px] font-Light flex justify-center lg:mb-30 text-[32px] mb-[7px] leading-[50px]",
  textDesc:
    "textDesc philiyFiveTxt lg:w-[750px] w-full mx-auto flex flex-wrap text-[18px] mb-[20px] px-15 tracking-[0]",
}

export const QUOTE_WITH_TEXT = {
  imgTxtContainer:
    " QUOTE_WITH_TEXT lg:top-[-9rem] lg:left-[116px] flex flex-wrap lg:flex-nowrap items-center justify-between max-w-full pb-16 my-0 mx-auto absolute w-full lg:px-[0px] px-[15px] lg:w-[319px] z-[2]",
  wrapper:
    "wrapper QUOTE_WITH_TEXT lg:max-w-[1170px] mx-auto  relative top-[-140px] lg:top-[-120px]",
  imgWrapper: "lg:mx-[20px] lg:my-auto mx-auto mt-0 mb-10 w-full flex w-[70px]",
  textImg:
    "lg:rounded-[20px] rounded-t-[20px] w-full md:h-[70px] md:w-[70px] lg:h-[50px] lg:w-[50px] h-[70px] w-[70px]",
  textContent:
    "my-0 mx-auto px-0 py-8 relative text-white w-full bg-darkBlue lg:bg-transparent lg:absolute lg:text-white lg:width-1/2 lg:top-[15%] lg:left-[10%] text-3xl lg:w-[400px] lg:text-left text-center",
  textHead: "text-white text-[30px] sdfsf",
  textDesc:
    "textDesc lg:w-3/4 md:w-[30%] w-[70%] lg:w-auto mx-auto flex  leading-[21px] text-center justify-center lg:text-left",
  textLink: "textLink",
  textWrpr:
    "absolute lg:top-[0px] text-white text-[20px] lg:w-[255px] w-full lg:ml-[80px] lg:mt-0 mt-[120px] left-0",
}
export const authorContent = {
  imgTxtContainer:
    "lg:flex my-auto mx-auto lg:absolute w-[28%] lg:bottom-[30%] lg:left-[10%] py-20",
  imgWrapper: "w-[70px] lg:mr-[15px] my-0 mx-auto",
  textImg: "",
  textContent: "text-white text-md lg:text-left text-center",
  textHead: "",
  textDesc:
    "text-white absolute text-[15px]  top-[-30px] px-auto w-full text-center",
  textLink: "",
  imgBtn: "",
}

export const blueBgImageGrid = {
  imgTxtContainer: "imgTxtContainer text-center",
  imgWrapper:
    "h-min overflow-hidden rounded-[2rem] borderActivepx-auto text-sm tracking-wide text-darkBlue font-medium before:pr-5 w-[195px] grid mx-auto",
  textImg: " ",
  textContent: "relative w-full px-auto",
  textHead:
    "text-xl  absolute top-[-52px] text-white px-auto w-full text-center'",
  textDesc: "",
  textLink: "flex px-auto",
  link: "link",
  imgBtn: "",
}

export const rangeCard = {
  imgTxtContainer:
    "bg-darkBlue rounded-[20px] items-center justify-between max-w-full my-0 mx-auto relative pb-25",
  wrapper: "",
  imgWrapper: " mx-auto mt-0 mb-10 pb-40",
  textImg:
    "rounded-[2rem]  hover:scale-[1.05] transition-all duration-1000 mx-auto ",
  textContent:
    "text-lg leading-7 text-center w-[354px] m-w-[354px] text-[#7f7f7f] mx-auto my-auto relative",
  textHead:
    "text-white absolute text-2xl  bottom-[100px] px-auto w-full text-center ",
  textDesc: "",
  imgBtn:
    "min-h-[50px] leading-39 text-white w-[300px] rounded-100 border-2 border-white absolute bottom-[25px] left-[5%] hover:bg-white hover:text-darkBlue animButton",
  textLink: "",
}

export const SLIDER_TEXT = {
  imgTxtContainer:
    "lg:px-auto md:w-[720px] w-[360px] lg:min-h-446  mx-auto float-none clear-both relative transition-all max-w-full",
  imgWrapper: "",
  textImg: "rounded-20 md:h-auto h-[360px]  w-auto ",
  textContent: "",
  textHead: "",
  textDesc: "",
  textLink: "",
  imgBtn: "",
  textWrpr:
    "text-center absolute left-0 bottom-0 w-full pt-[90px] pb-[21px] px-10 lg:text-[31px] text-[21px] lg:leading-10 text-white rounded-b-20 bg-videoGradient",
}
export const LEFT_QUOTE_CONTAINER = {
  imgTxtContainer:
    " lg:w-[1170px] flex flex-wrap flex-row-reverse lg:flex-nowrap items-center justify-between max-w-full my-0 mx-auto relative md:p-0 p-8",
  imgWrapper:
    "lg:mx-[20px] lg:my-auto mx-auto mt-0 mb-10 lg:w-[45%] flex items-center md:px-30 lg:px-0",
  textImg: "w-full ",
  textContent:
    "text-lg leading-7 text-center w-[354px] m-w-[354px] text-[#7f7f7f] mx-auto my-auto",
  textWrpr:
    "md:w-[460px] md:max-w-full mx-auto text-center p-8 lg:mb-0 mb-30 leading-[46.8px]",
  textHead:
    "text-[#00358e] font-Bold text-[30px] md:text-[39px] mb-20 font-bold mx-auto md:child:leading-[46.8px] child:leading-[36px]",
  textDesc:
    "description text-[#7f7f7f] text-[17px] md:text-[23px] text-[17px] mb-20 md:leading-[32.2px] leading-[23.8px]",
  textLink: "text-sm buttonEffect2 recipeBtn",
  imgBtn: "",
  bgImg: "absolute w-full",
  wrapper: "bg-no-repeat bg-left-top bg-[length:100%_100%]",
}
export const ERROR_CONTAINER = {
  imgTxtContainer: "",
  imgWrapper: "",
  textImg: "",
  textWrpr: "mx-auto md:w-[437px] px-12 md:px-0 text-center",
  textContent:
    "text-lg leading-7 text-center w-[354px] m-w-[354px] text-[#7f7f7f] mx-auto my-auto",
  textHead:
    "md:text-[30px] text-[60px] tracking-[1px] md:leading-[30px] leading-[60px] my-15",
  textDesc: "text-[20px] leading-[28px] my-15",
  textLink:
    "uppercase font-Bold bg-white border-solid border-2 border-darkBlue block text-[18.75px] leading-[26.25px] mx-auto py-15 px-20 text-center w-[296px] h-[58px] max-w-[90%] rounded-[30px] my-15 hover:border-darkBlue hover:border-2 hover:text-white hover:bg-darkBlue transition duration-500 ease-in-out",
  imgBtn: "",
  wrapper:
    "pt-[85px] md:pb-[250px] pb-[50px] min-h-full relative top-[-70px] bg-cover bg-no-repeat bg-left-top",
}

export const TEXT_WITH_WHITE_BG = {
  wrapper: "",
  imgTxtContainer:
    "text-white bg-darkBlue lg:w-[945px] md:w-[440px] rounded-20 bg-white md:mx-auto p-25 mx-10",
  imgWrapper: "hi",
  textImg: "rounded-20 md:h-auto h-[360px]  w-auto ",
  textContent: "1",
  textHead:
    "text-[40px] text-darkBlue mt-5 text-center w-full font-Bold lg:mx-auto md:px-15 leading-[49px] ",
  textDesc:
    "text-[25px] flex w-full px-auto mx-auto text-center justify-center leading-30 lg:px-10 md:px-0 tracking-[0] mt-15 mb-20 lg:w-[750px] text-[#7f7f7f] formSubmitCard",
  textLink:
    "before:bg-downloadIcon before:bg-no-repeat before:bg-left-top before:bg-[length:100%_100%] before:inline-block before:mr-10 before:relative before:top-6 before:w-24 before:h-24 downloadBtn",
  imgBtn: "5",
  textWrpr: "",
}

export const BOTTOM_TEXT = {
  wrapper: "wrapper",
  imgWrapper: "imgWrapper",
  imgTxtContainer: "imgTxtContainer ",
  bgImg: "bgImg",
  textDesc:
    "textDesc text-[14px] md:text-[21px] font-Regular text-left text-[#29333d] leading-[21px] md:leading-[31.5px] tracking-[0.53px] [&>p]:mb-[25px] [&>p>a]:tracking-[2.2px] [&>p>a]:font-bold [&>p>a:hover]:text-orange [&>p>a:hover]:underline",
  textImg:
    "w-full block align-middle text-[16px] tracking-normal leading-[24px] overflow-x-clip overflow-y-clip align-left lg:h-[575px] object-cover",
  subimgWrpr:
    "mt-[-8px] min-h-[0px] text-left md:pr-[10px] lg:pr-[0px] md:bg-center md:bg-cover px-[0px] mx-auto",
  textHead:
    "text-[24px] lg:text-[48px] font-Regular leading-[28.8px] text-left lg:leading-[57.6px] tracking-normal text-green mb-[35px] font-Light",
  textWrpr: "textWrpr lg:max-w-lg xl:max-w-xl mx-auto px-[35px] md:px-[40px] lg:px-[15px] py-[30px] md:py-[50px]",
  videoWrapper: 'videoWrapper',
}


export const NEWSPAGE_DETAIL = {
  wrapper: "xtest",
  BusLink: "md:mb-[16px] mb-[50px] flex flex-wrap badgefa busLiknList justify-start flex w-full ",
  BusLinkIn: "",
  BusLinkL:
    "text-[12px] lg:text-[16px] uppercase font-Bold text-purple tracking-[0.53px] md:tracking-[2.2px] leading-[24px] hover:text-orange hover:underline after:content-[','] after:mr-[3px] ",
  imgTxtContainer: "",
  imgWrapper: "",
  textImg: "w-full",
  textContent: "",
  textHead: "",
  textDesc: "newsdetailTextDesc",
  textLink: "",
  imgBtn: "",
  textWrpr: "",
}
export const NEWSPAGE_DETAIL_BOTTOM = {
  wrapper:
    "flex flex-wrap md:px-[15px] md:pb-[75px] px-[35px] pb-[45px] newsDetailWrapper xl:max-w-xl xl:w-full md:max-w-md lg:max-w-lg mx-auto ",
  BusLink: "md:mb-[16px] mb-[50px] flex flex-wrap badgefa",
  BusLinkIn: "",
  BusLinkL:
    "text-[12px] lg:text-[16px] uppercase font-Bold text-purple tracking-[2.2px] leading-[24px] hover:text-orange hover:underline after:content-[','] ",
  imgTxtContainer: "",
  imgWrapper: "",
  textImg: "",
  textContent: "1",
  textHead: " p",
  textDesc: "newsdetailTextDesc newsdetailTextBottom",
  textLink: "c",
  imgBtn: "5",
  textWrpr: "",
}

export const NDP_LEFT = {
  wrapper:
    "flex flex-wrap md:px-[15px] md:pb-[85px] px-[35px] pb-[45px] newsDetailWrapper xl:max-w-xl xl:w-full md:max-w-md lg:max-w-lg mx-auto xl:py-[75px] py-[50px] ",
  imgTxtContainer:
    "flex flex-wrap flex-row-reverse items-start ndpwithLearnmore",
  imgWrapper: "flex flex-wrap  lg:pl-[100px] lg:w-[66.66%] w-100% mb-[50px] ",
  textWrpr: "w-full md:pb-0 lg:w-[33.33%] lg:pr-[30px] min-h-[315px] md:min-h-full",
  textContent: "1",
  textHead:
    "text-green text-Ndp_GR xl:text-[60px] xl:mb-[35px] font-Light text-[36px] mb-[20px] max-[767px]:max-w-[357px]",
  textDesc: "text-Ndp_GR-Desc",
  textLink: "c",
}

export const HOMEPAGE_LEFT_IMAGE = {
  wrapper:
    "flex flex-wrap md:px-[15px] md:pb-[85px] px-[35px] pb-[45px] newsDetailWrapper xl:max-w-xl xl:w-full md:max-w-md lg:max-w-lg mx-auto xl:py-[75px] py-[50px] ",
  imgTxtContainer:
    "flex flex-wrap flex-row items-start ndpwithLearnmore justify-between",
  textWrpr: "w-full md:pb-0 lg:w-[40%] lg:pl-[10%] ",  
  mainHeading: "text-[#4f2170] uppercase mb-[15px] md:mb-[40px] leading-[21px] font-bold text-[10px] md:text-[21px] tracking-[0.53px] font-Bold",  
  imgWrapper: "flex flex-wrap lg:w-[60%] w-100% mb-[50px] ",
  videoWrapperContainer:'videoWrapperContainer lg:w-[60%] w-100% mb-[50px]',
  textContent: "1",
  textHead:
    "text-green text-Ndp_GR xl:text-[60px] xl:mb-[35px] font-Light text-[36px] mb-[20px] max-[767px]:max-w-[357px]",
  textDesc: "text-Ndp_GR-Desc",
  textLink: "c",
}

export const HOMEPAGE_RIGHT_IMAGE = {
  ...HOMEPAGE_LEFT_IMAGE,
  imgTxtContainer:
    "flex flex-wrap flex-row-reverse justify-between items-start ndpwithLearnmore",
  textWrpr: "w-full md:pb-0 lg:w-[40%] lg:pr-[13%] ",  
}


export const TWO_COL_6_WIDTH = {
  ...defaultStyle,
  wrapper:
    "twoColoumSection md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto w-full relative px-[35px] lg:px-0 my-[30px] block lg:my-[50px]",
  textHead:
    "textHead text-green text-[24px] lg:text-[48px] font-Light leading-[1.2] tracking-normal  mb-[35px] px-0 mt-[-12px] font-light box-border text-left",
  textWrpr: "textWrpr pb-30 lg:pb-0 w-full lg:w-1/2 lg:px-[15px]",
  imgWrapper: "imgWrapper lg:w-1/2 lg:pl-[35px] lg:pr-[30px]",
  imgTxtContainer: "imgTxtContainer flex flex-col-reverse lg:flex-row-reverse block",
  videoWrapper: "videoWrapper w-1/2",
  textContent: "textContent",
  videoWrapperContainer: "w-full lg:w-1/2 flex flex-col videowrapper-container",
  caption: "text-[12px] md:text-[21px] font-bold tracking[.53px] px-0 lg:px-[30px]",
  textDesc: "textDesc text-left md:mb-0 mb-[25px] [&>p]:mb-[35px] md:text-[21px] px-[0px] text-[14px] font-Regular tracking-[0.53px] leading-[1.5] text-black mt-0 box-border [&>ul]:list-disc [&>ul]:md:pl-[25px] [&>ul]:md:mb-[16px] [&>p>a]:!text-purple [&>p>a:hover]:!text-orange [&>p>a]:tracking-[2.2px] [&>p>a]:font-bold [&>p>a:hover]:underline [&>p>a:hover]:!text-orange [&>a]:font-bold [&>a:hover]:underline [&>a:hover]:!text-orange [&>p>strong]:mb-[25px] [&>h3]:text-blue500 [&>h3]:font-MDLZBiteType [&>h3]:text-[16px] md:[&>h3]:!text-[28px] [&>h3]:mb-[8px] [&>h3]:tracking-normal [&>h3]:leading-[19.2px] md:[&>h3]:!leading-[33.6px]",
  buttonLinkWrpr: "buttonLinkWrpr flex justify-center py-[40px] text-center",
  textLink: "textLink",
  mainHeading: 'mainHeading',
}

export const TWO_COL_8_4_WIDTH = {
  ...TWO_COL_6_WIDTH,
  wrapper:
    "twoColoumSection md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto w-full relative px-[35px] lg:px-[15px] py-[30px] md:py-[50px] block",
  imgTxtContainer: "imgTxtContainer flex flex-col lg:flex-row block",
  textDesc: "textDesc  text-left md:text-[21px] px-[0px] text-[14px] font-Regular tracking-[0.53px] text-black mt-0 box-border ",
  textHead:
    "textHead text-green text-[24px] md:text-[48px] font-Light leading-[1.2] pb-[35px] ",
  textWrpr: "textWrpr w-full lg:w-2/3 test px-0 lg:px-[30px]",
  imgWrapper: "imgWrapper lg:w-1/3 test px-[20px]",
  BusLinkIn: "BusLinkIn",
  BusLink: "BusLink md:w-2/5",
  textImg: 'textImg pb-[25px] lg:pb-0 w-full',
}
export const TWO_COL_8_4_WIDTH_WITH_BG = {
  ...TWO_COL_8_4_WIDTH,
  wrapperFullBg: "wrapperFullBg bg-grayWhite",
}

export const TABLE_GRID_IMAGES = {}

export const TWO_COL_6_WIDTH_WITH_SMALL_HEADING = {
  ...TWO_COL_6_WIDTH,
  wrapper:
    "twoColoumSection md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto w-full relative px-30 lg:px-[15px] py-[30px] md:py-[50px] block",
  textHead:
    "textHead text-green text-[24px] md:text-[24px] lg:text-[48px] font-Light leading-[1.2] md:mb-[35px] lg:mb-[0px] md:mt-[-12px] lg:mt-[0px] ml-[-10px] md:ml-[-35px] lg:ml-[0px]",
  textDesc:
    "textDescClimate text-[16px] md:text-[21px] font-Regular leading-[24px] text-left text-[#29333d] md:leading-[1.5] tracking-[0.53px] pt-[50px]",
  imgWrapper: "imgWrapper",
  imgTxtContainer:
    "imgTxtContainer flex flex-col-reverse lg:flex-row-reverse block",
  videoWrapper: "videoWrapper w-1/2",
}
export const TABCONTENT_WITH_IMAGETEXT = {
  wrapper: " ",
  imgTxtContainer:
    "mindfullPortionTabContentWrap flex flex-wrap lg:flex-nowrap items-center justify-start max-w-full pb-16 my-0 mx-auto md:left-[90px]",
  imgWrapper: "lg:mx-[20px] lg:my-auto mx-auto mt-0 mb-10",
  textImg: "w-full ",
  textContent:
    "text-lg leading-7 text-center w-[354px] m-w-[354px] text-[#7f7f7f] mx-auto my-auto",
  textHead: " mindfullPortionList hidden md:block text-left font-Light text-[24px] lg:text-[48px] text-green mb-[35px] tracking-[1.2px] lg:leading-[50px]",
  textDesc: "textDesc [&>p]:mb-[30px] last:[&>p]:mb-0 [&>p>a]:!text-purple [&>p>a:hover]:!text-orange [&>p>a]:tracking-[2.2px] [&>p>a]:font-bold [&>p>a:hover]:underline [&>strong]:text-[14px] md:[&>strong]:text-[21px] [&>strong]:tracking-[0.53px] [&>strong]:leading-[21px] [&>ul]:my-[20px] [&>ul]:list-disc [&>strong]:text-left [&>p>em]:text-[21px] [&>em]:italic [&>em]:font-normal [&>em]:leading-[24px] [&>em]:text-center px-[10px] [&>ul>li]:mb-30",
}
export const TABCONTENT_WITH_IMAGETEXT_WITH_VIDEO = { 
  wrapper: " ",
  imgTxtContainer:
    "relative mindfullPortionTabContentWrap flex flex-wrap flex-col-reverse items-center justify-start max-w-full pb-16 my-0   ",
  imgWrapper: "lg:mx-[20px] lg:my-auto mx-auto mt-0 mb-10",
  textImg: "w-full ",
  textContent:
    "text-lg leading-7 text-center w-[354px] m-w-[354px] text-[#7f7f7f] mx-auto my-auto",
  textHead: " mindfullPortionList hidden md:block text-left font-Light text-[24px] lg:text-[48px] text-green mb-[35px] tracking-[1.2px] lg:leading-[50px]",
  textDesc: "textDesc [&>p]:mb-[30px] last:[&>p]:mb-0 [&>p>a]:!text-purple [&>p>a:hover]:!text-orange [&>p>a]:tracking-[2.2px] [&>p>a]:font-bold [&>p>a:hover]:underline [&>strong]:text-[14px] md:[&>strong]:text-[21px] [&>strong]:tracking-[0.53px] [&>strong]:leading-[21px] [&>ul]:my-[20px] [&>ul]:list-disc [&>strong]:text-left [&>p>em]:text-[21px] [&>em]:italic [&>em]:font-normal [&>em]:leading-[24px] [&>em]:text-center px-[10px] [&>ul>li]:mb-30",
  }
export const TWO_COL_3_9_WIDTH = {
  imgTxtContainer:
    "flex flex-col md:flex-row px-[15px]",
  imgWrapper:
    "mx-auto mt-0 mb-10  md:w-1/4 w-full md:px-30 lg:px-0 px-15",
  textImg: "w-full ",
  textContent:
    "text-lg leading-7 text-left  text-[#7f7f7f] mx-auto my-auto",
  textWrpr:
    " md:w-3/4 w-full  text-left px-[35px] lg:mb-0 mb-30",
  textHead:
    "text-green font-light text-[24px] md:text-[36px] mb-[35px] font-regular mx-auto px-[20px] md:px-[0px]",
  textDesc:
    "description text-black text-[18px] lg:text-[21px] [&>p]:mb-[30px] px-[20px] md:px-0 [&>ul]:list-disc md:[&>ul]:pl-[20px]",
  textLink: "text-sm buttonEffect2 recipeBtn",
  imgBtn: "",
  bgImg: "absolute w-full",
  wrapper: "executiveSummary lg:max-w-lg xl:max-w-xl md:max-w-md mx-auto md:p-0 py-[30px] lg:py-[50px]",
}
export const ICON_WITH_LABEL = {
  wrapper: "wrapper",
  imgTxtContainer: "imgTxtContainer flex flex-wrap lg:flex-nowrap items-left justify-start translate-y-[-50%]",
  imgWrapper: "imgWrapper mr-[20px]",
  textImg: "textImg w-[20px] h-[20px]",
  textContent: "textContent text-lg leading-7 text-center w-[354px] m-w-[354px] text-[#7f7f7f] mx-auto my-auto",
  textHead: "textHead text-[#00358e] font-bold	mx-auto",
  textDesc: "",
  textLink: "",
  imgBtn: "",
}
export const PACKAGING_PLASTICS_IMAGE_WITH_TEXT = {
  imgTxtContainer: "test me",
  imgWrapper: "tesrrr",
  wrapper: "tabbingContentWrap mb-[100px]",
  subimgWrpr: "testfor",
  textContent: "testrr",
  textHead: "textHead md:[&>p]:text-[24px] lg:[&>p]:text-[48px] md:[&>p]:leading-[28.8px] lg:[&>p]:leading-[57.6px] md:[&>p]:mt-[-12px] text-green font-Light md:mb-[35px] [&>p]:tracking-normal",
  textDesc: "textDesc md:px-[20px] lg:px-[0px] [&>br]:hidden [&>p]:mb-[30px] [&>h2]:mb-[30px] [&>h2]:text-[21px]  [&>h2]:tracking-[0.53px] [&>h2]:font-Bold leading-[31.5px] "
}

export const PACKAGING_PLASTICS_IMAGE_WITH_TEXT_INSIDE = {
  wrapperFullBg: "wrapperFullBg tableIcon  ",
  wrapper: "wrapper flex items-center md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto [&>div>img]:w-[20px] [&>div>img]:h-[20px]  md:[&>div>img]:!w-[30px] md:[&>div>img]:!h-[30px] [&>div>img]:mr-[12px] md:[&>div>img]:!mr-[5px] [&>div>img]:bg-contain  ",
  imgTxtContainer: "imgTxtContainer flex flex-wrap lg:flex-nowrap items-center justify-start md:ml-[22px]",
  imgWrapper: "imgWrapper mr-[20px]",
  textImg: "textImg w-full",
  textContent: "textContent text-lg leading-7 text-center w-[354px] m-w-[354px] text-[#7f7f7f] mx-auto my-auto",
  textHead: "textHead [&>p]:text-[14px] md:[&>p]:text-[21px] font-Regular leading-31.5px [&>p]:align-top [&>p]:tracking-[0.35px]",
  textDesc: "",
  textLink: "",
  imgBtn: "",
}
export const IMAGE_IN_TABLE = {
  wrapper: "wrapper",
  imgTxtContainer: "imgTxtContainer",
  imgWrapper: "imgWrapper",
  textImg: "textImg",
  textContent: "textContent",
  textHead: "textHead",
  textDesc: "textDesc",
  textLink: "textLink",
  imgBtn: "imgBtn",
}

export const PACKAGING_PLASTICS_8_4 = {
  ...TWO_COL_6_WIDTH,
  wrapper:
    "twoColoumSection md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto w-full relative md:px-30 px-[35px] lg:px-0  md:py-[50px] ",
  imgTxtContainer: "imgTxtContainer flex flex-col-reverse lg:flex-row-reverse",
  textHead:
    "textHead text-green text-[24px] lg:text-[48px] font-Light leading-[1.2] pb-[35px]",
  textWrpr: "textWrpr md:px-15 pb-30 lg:pb-0 w-full lg:w-8/12",
  textDesc: "textDescPLRight ",
  imgWrapper: "imgWrapper lg:w-4/12 px-15",
  BusLinkIn: "BusLinkIn",
  BusLink: "BusLink md:w-2/5",
}

export const TWO_COL_PURPLE_CTA = {
  ...TWO_COL_6_WIDTH,
  wrapper:
    "twoColoumSection md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto w-full relative md:px-30 px-[35px] lg:px-0  md:py-[50px] ",
  imgTxtContainer: "imgTxtContainer flex flex-col-reverse lg:flex-row-reverse",
  textHead:
    "textHead text-green text-[24px] lg:text-[48px] font-Light leading-[1.2] pb-[35px]",
  textWrpr: "textWrpr md:px-15 pb-30 lg:pb-0 w-full lg:w-8/12",
  textDesc: "textDescPLRight ",
  imgWrapper: "imgWrapper lg:w-4/12 px-15 text-center",
  BusLinkIn: "BusLinkIn",
  BusLink: "BusLink md:w-2/5",
  textLink: "mt-40 font-bold inline-block py-[20px] px-[45px] border-2 border-solid border-purple rounded-[40px] uppercase text-[21px] text-center leading-[21px] tracking-[2.2px] duration-500 font-Regular bg-purple hover:bg-[#724D8D] hover:border-[#724D8D] text-white"
}

export const TWO_COL_PURPLE_CTA_REVERSE = {
  ...TWO_COL_PURPLE_CTA,
  imgTxtContainer: "imgTxtContainer flex flex-col-reverse lg:flex-row",
}

export const RIGHT_QUOTE_CONTAINER = {
  wrapper: "relative",
  imgTxtContainer: "flex flex-wrap w-full md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto md:px-[15px] px-[35px] pb-[50px]",
  imgWrapper: "lg:w-[25%] w-full lg:pr-[15px] mb-[30px] lg:mb-[30px]",
  textImg: "w-full ",
  textContent:
    "text-lg leading-7 text-center w-[354px] m-w-[354px] text-[#7f7f7f] mx-auto my-auto",
  textWrpr: "lg:w-[75%] w-full lg:pl-[15px]",
  textHead: "text-[#00358e] font-bold	mx-auto",
  textDesc: "[&>h3]:text-[16px] md:[&>h3]:!text-[28px] max-[991px]:text-center lg:ml-[25px] [&>h3]:font-MDLZBiteType [&>br]:hidden text-black md:[&>h3]:!leading-[1.2] [&>h3]:leading-[19.2px] [&>h3]:mb-[8px] [&>h3]:tracking-normal [&>p]:text-[18px] [&>p]:leading-[27px] [&>p]:tracking-[0.53px] [&>p]:font-Regular",
  textLink: "",
  imgBtn: "",
}
export const TWO_COL_8_4_WIDTH_BLUE_TITLE = {
  ...TWO_COL_8_4_WIDTH,
  textHead:
    "textHead text-blue500 font-MDLZBiteType text-[16px] md:text-[28px] leading-[1.2] mb-[8px] tracking-normal",
}

export const TWO_COL_8_4_WIDTH_BLACK_TITLE = {
  ...TWO_COL_8_4_WIDTH,
  textHead:
    "textHead text-[#212529] text-[16px] md:text-[24px] font-[600] leading-[29px] mb-[8px]",
}
export const TWO_COL_3_9_WIDTH_BLUE_TITLE = {
  ...TWO_COL_3_9_WIDTH,
  imgWrapper:
    "imgWrapper md:w-1/4 lg:pl-35",
  textHead:
    "textHead text-blue500 font-MDLZBiteType text-[16px] md:text-[28px] leading-[1.2] mb-[8px] tracking-normal",
  imgTxtContainer:
    "md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto w-full relative px-30 lg:px-0 md:pb-[50px] flex flex-wrap",
  textWrpr:
    " md:w-3/4 w-full text-left md:px-15",
  textDesc:
    "description max-md:mt-15 md:px-15 md:px-30 [&>p]:text-[21px] [&>p]:mb-[35px] [&>p]:last:mb-0 [&>p]:text-black [&>h3]:font-MDLZBiteType [&>h3]:text-[#2d6eaa] [&>h3]:text-[16px] lg:[&>h3]:text-[28px] [&>h3]:leading-[33px] [&>h3]:mb-[8px] [&>h4]:text-[#212529] [&>h4]:mb-[8px] [&>h4]:text-[#212529] [&>h4]:font-[500] [&>h4]:text-[26px] [&>h4]:leading-[29px] [&>h3]:text-center lg:[&>h3]:!text-left [&>h4]:text-center lg:[&>h4]:!text-left [&>h4]:font-['Segoe_UI_Semibold']",
}

export const TWO_COL_6_WIDTH_REVERSE = {
  ...TWO_COL_6_WIDTH,
  imgTxtContainer: "imgTxtContainer flex flex-col lg:flex-row block md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto w-full",
  wrapperFullBg: "wrapperFullBg max-md:pb-0 max-md:mb-0 my-[50px] lg:mt-0",
  wrapper: "twoColoumSection md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[15px]",

  imgWrapper: "imgWrapper lg:w-1/2 pl-0 mb-[30px] lg:mb-0",
  textWrpr: "textWrpr pb-30 lg:pl-35 lg:pb-0 w-full lg:w-1/2 px-[35px]",
  textHead:
    "textHead text-green text-[24px] lg:text-[48px] font-light tracking-normal font-Light leading-[1.2] mb-[35px]",
}

export const BOTTOM_SMALL_TEXT = {
  ...BOTTOM_TEXT,
  textDesc: "font-Regular text-[14px] leading-[21px] [&>p]:w-full  [&>p]:items-center [&>p>img]:inline [&>p>img]:mx-[5px] [&>p>a]:font-Regular [&>p>a]:font-bold [&>p]:italic [&>p>a:hover]:underline [&>p>a:hover]:text-orange [&>p>a]:text-purple [&>p>a]:text-[14px] md:[&>p>a]:text-[21px] [&>p>a]:tracking-[2.2px] [&>p>a]:leading-[31.5px] lg:px-[20px] ",
  textWrpr: "textWrpr bottomSmallText max-w-xl mx-auto px-[15px] py-[30px]",
  textWrpr: "textWrpr px-15 pb-30 lg:pb-0 w-full",
  textImg:
    "w-full block align-middle text-[16px] tracking-normal leading-[24px] overflow-x-clip overflow-y-clip align-left object-cover",
}

export const TWO_COL_8_4_WIDTH_REVERSE = {
  ...TWO_COL_8_4_WIDTH,
  imgTxtContainer: "imgTxtContainer flex flex-col-reverse lg:flex-row-reverse block",
  textWrpr: "textWrpr w-full lg:w-2/3 pb-[30px] lg:pb-0",
  textDesc: "textDesc text-left md:text-[21px] px-[0px] lg:pr-[30px] text-[14px] font-Regular tracking-[0.53px] text-black mt-0 box-border [&>p]:mb-[25px]  lg:[&>p]:mb-[35px] [&>h2]:text-green [&>h2]:font-Light [&>h2]:text-[24px] [&>h2]:leading-[1.2] [&>h2]:mb-[35px] lg:[&>h2]:text-[48px] [&>ul]:ml-[12px] [&>ul>li]:list-disc ",
  textImg: 'textImg pb-[25px] lg:pb-0 w-full',
}

export const TWO_COL_6_WIDTH_WITH_BG = {
  ...TWO_COL_6_WIDTH,
  wrapper:
    "twoColoumSection md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto w-full relative px-[20px] md:px-[15px] lg:px-[0px] py-[30px] lg:py-[50px] block",
  wrapperFullBg: "wrapperFullBg bg-grayWhite",
  imgWrapper: "imgWrapper w-full lg:w-1/2 lg:pl-[20px] lg:pr-[15px] mb-20 lg:mb-0",
  textImg: "textImg aspect-[615/346] px-[15px] lg:px-[15px]",
  textWrpr: "textWrpr px-[20px] lg:px-[15px] lg:pb-0 w-full lg:w-1/2",
  textHead:
    "textHead text-green text-[24px] lg:text-[48px] font-Light leading-[1.2] mb-[35px] font-light box-border text-left md:mx-[-12px] lg:mx-[0px]",
  textDesc: "textDesc text-left [&>p]:mb-[35px] md:text-[21px] px-[0px] lg:px-[0px] text-[14px] font-Regular tracking-[0.53px] text-black mt-0 box-border [&>ul]:!list-disc [&>ul]:pl-[25px] [&>p>a]:!text-purple [&>p>a]:!font-bold [&>p>a]:!tracking-[0.53px] md:[&>p>a]:!tracking-[2.2px] hover:[&>p>a]:!text-orange hover:[&>p>a]:border-b-2 hover:[&>p>a]:no-underline",
  mainHeading: "headingPurple text-[36px] md:text-[60px] font-MDLZBiteType tracking-[1.2px] leading-[43.2px] text-purple mb-[25px] md:mb-[50px] mx-auto px-[15px] py-[40px] text-center md:text-left max-w-[200px] md:max-w-md lg:max-w-lg xl:max-w-xl"
}
export const TWO_COL_10_2_WIDTH = {
  ...TWO_COL_6_WIDTH,
  wrapper:
    "twoColoumSection md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto w-full relative px-[15px] md:px-[35px] lg:px-0 pt-[30px] pb-0 md:py-[30px] md:pt-[50px] md:pb-[50px] block md:mb-0",
  textWrpr: "textWrpr pb-30 lg:pb-0",
  mainHeading: "mainHeading text-green text-[24px] lg:text-[48px] font-Light leading-[1.2] mb-[35px] px-0 md:px-[15px] lg:px-[20px] mt-[-12px] font-light box-border text-left md:mx-[-12px] ",
  textDesc: "textDesc text-left md:mb-0  mb-[25px] md:text-[21px] px-[0px] lg:px-[15px] text-[14px] font-Regular tracking-[0.53px] text-black mt-0 box-border [&>p]:mb-[35px]",
  imgWrapper: "imgWrapper w-full lg:ml-[20px] flex items-center max-w-[240px] mb-[35px] md:mb-0",
  imgTxtContainer: "imgTxtContainer flex flex-col md:flex-row-reverse block items-center",
}
export const TWO_COL_10_2_WIDTH_REVERSE_GRAY_BG = {
  ...TWO_COL_6_WIDTH_REVERSE,
  wrapperFullBg: "wrapperFullBg bg-grayWhite py-[30px] md:py-[50px]",
  wrapper:
    "twoColoumSection md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto w-full relative px-[35px] lg:px-[15px] block ",
  mainHeading: "mainHeading text-green text-[24px] lg:text-[48px] font-Light leading-[1.2] mb-[35px] px-0 md:px-[15px] lg:px-[20px] mt-[-12px] font-light box-border text-left md:mx-[-12px] ",
  imgTxtContainer: "imgTxtContainer flex flex-col md:flex-row mb-0 items-center md:items-start block md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto w-full",
  imgWrapper: "imgWrapper w-full mb-[35px] md:mb-0 md:mr-[20px] max-w-[240px]",
  textWrpr: "textWrpr w-full",
  textLinkWrapper: "textLinkWrapper mt-[120px] md:mt-[200px]",
  textLink: "textLink linkClass bg-purple table text-center text-[14px] lg:text-[21px] transition-all leading-[21px] duration-[.5s] tracking-[2.2px] uppercase border-[2px] border-purple text-white hover:bg-lightpurple hover:border-lightpurple font-Bold px-[45px] py-[20px] rounded-[40px] lg:float-left mx-auto xl:mr-[200px] xl:ml-[250px] my-[35px] lg:mt-[50px] md:text-[21px] event_external_link",

}
export const TWO_COL_10_2_WIDTH_REVERSE_GRAY_WIDTHOUT_BG = {
  ...TWO_COL_10_2_WIDTH_REVERSE_GRAY_BG,
  wrapperFullBg: "wrapperFullBg py-[30px] md:py-[50px]",
}
export const TWO_COL_6_WIDTH_REVERSE_WITH_BG = {
  ...TWO_COL_6_WIDTH_WITH_BG,
  imgTxtContainer: "imgTxtContainer flex flex-col lg:flex-row block",
  wrapperFullBg: "wrapperFullBg bg-grayWhite py-[50px] mb-[50px]",
  wrapper:
    "twoColoumSection md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto w-full relative px-[20px] md:px-[15px] lg:px-[0px] block",
}
export const TWO_COL_6_WIDTH_REVERSE_WITHOUT_BG = {
  ...TWO_COL_6_WIDTH_REVERSE_WITH_BG,
  wrapperFullBg: "wrapperFullBg py-[50px] mb-[50px]",
  mainHeading: "headingPurple text-[36px] md:text-[60px] font-MDLZBiteType tracking-[1.2px] leading-[43.2px] text-purple mb-[25px] md:mb-[50px] mx-auto lg:ml-10 px-[15px] py-[40px] text-center md:text-left max-w-[200px] md:max-w-md lg:max-w-lg xl:max-w-xl",
  textDesc: "textDesc text-left [&>p]:mb-[35px] md:text-[21px] px-[0px] lg:px-[0px] text-[14px] font-Regular tracking-[0.53px] text-black mt-15 lg:mt-[35px] lg:ml-15 box-border [&>ul]:!list-disc [&>ul]:pl-[25px] [&>p>a]:!text-purple [&>p>a]:!font-bold [&>p>a]:!tracking-[0.53px] md:[&>p>a]:!tracking-[2.2px] hover:[&>p>a]:!text-orange hover:[&>p>a]:border-b-2 hover:[&>p>a]:no-underline",
}
export const TWO_COL_GREEN_TEXT_WITH_IMG = {
  ...NEWSPAGE_DETAIL,
  wrapper: "py-[75px]",
  imgWrapper: "px-[35px] md:pr-[70px] md:pl-[130px] mb-[30px] md:mb-0",
  textImg: "w-full md:w-[95%]",
  imgTxtContainer: "flex flex-col md:flex-row-reverse justify-center ",
  textWrpr: "flex flex-col px-[35px] ",
  textHead: "text-[36px] md:text-[60px] my-[35px] max-w-[357px] text-[#287819] leading-[1.2] tracking-normal font-light",
  buttonLinkWrpr: "flex justify-center",
  textLink: "textLink text-[#4f2170] border-2 border-solid border-[#4f2170] leading-[21px] text-[21px] uppercase text-center rounded-[40px] px-[45px] py-[20px] tracking-[0.53px] md:tracking-[2.2px] font-bold inline-block hover:border-[#724D8D] hover:bg-[#724D8D] hover:text-[#fff] transition-all duration-500 mt-[35px] w-[90%] md:w-auto"
}
export const IMAGE_WITH_TITLE = {
  ...BOTTOM_TEXT,
  wrapper: "md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto w-full relative px-[15px] block my-[30px] lg:my-[50px]",
  mainHeading: "mainHeading md:mx-[-12px] text-green text-[24px] lg:text-[48px] font-Light leading-[1.2] mb-[35px] px-[20px]",
  textWrpr: "textWrpr",
  textImg: "w-full block align-middle text-[16px] tracking-normal leading-[24px] overflow-x-clip overflow-y-clip align-left",
}

export const SUSAGRI_IMAGE_WITH_TITLE = {
  ...BOTTOM_TEXT,
  wrapper: "sustainable-griculture flex justify-around w-full relative py-[80px] px-[15px] bg-[#4c5e26]",
  mainHeading: "mainHeading md:mx-[-12px] text-green text-[24px] lg:text-[48px] font-Light leading-[1.2] mb-[35px] px-[20px]",
  imgTxtContainer: "w-full lg:w-[25%] bg-white p-20 rounded-20",
  textWrpr: "textWrpr py-20",  
  textHead:
    "text-[26px] font-BwSurcoBold font-[400] leading-[31.2px] lg:leading-[31.2px] tracking-normal text-black text-center",
  textImg: "w-full block align-middle text-[16px] tracking-normal leading-[24px] overflow-x-clip overflow-y-clip align-left",
  subimgWrpr:
    "wrapper mt-0 min-h-[0px] text-left md:pr-[10px] lg:pr-[0px] md:bg-center md:bg-cover px-[0px] mx-auto overflow-hidden",
}
export const
  IMAGE_TOP_DESCRIPTION = {
    ...BOTTOM_TEXT,
    textImg:
      "w-full block align-middle text-[16px] tracking-normal leading-[24px] overflow-x-clip overflow-y-clip max-w-[960px] object-cover mx-auto",
    imgTxtContainer: "imgTxtContainerWrapper flex flex-col-reverse md:max-w-md lg:max-w-lg xl:max-w-xl px-[35px] lg:px-[15px] mx-auto",
    textDesc:
      "textDesc text-[16px] md:text-[28px] font-MDLZBiteType leading-[19.2px] text-center md:text-center lg:text-left text-[#29333d] tracking-normal",
    textWrpr: "textWrpr my-[30px] md:my-[50px]",
    subimgWrpr:
      "mt-[-8px] min-h-[0px] text-left md:pr-[10px] lg:pr-[0px] md:bg-center md:bg-cover px-[0px] mx-auto mb-[35px]",
  }

export const TWO_COL_8_4_REVERSE_WIDTH_BLUE_TITLE = {
  ...TWO_COL_8_4_WIDTH_BLUE_TITLE,
  wrapper:
    "twoColoumSection md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto w-full relative py-[30px] px-[35px] lg:px-0 md:py-[50px] block",
  imgTxtContainer: "imgTxtContainer flex flex-col-reverse lg:flex-row-reverse",
  textWrpr: "textWrpr w-full lg:w-2/3 test px-0 lg:px-[15px] mb-[30px] lg:mb-0",
}

export const RIGHT_IMG_LEFT_TEXT = {
  ...NDP_LEFT,
  wrapperFullBg: 'wrapperFullBg wrapper-video py-[50px] md:py-[75px] md:last-child:pb-0 lg:min-h-[650px]',
  wrapper:
    "flex flex-wrap md:px-[15px] px-[35px] newsDetailWrapper xl:max-w-xl xl:w-full md:max-w-md lg:max-w-lg mx-auto ",
  mainHeading: "text-[#4f2170] uppercase mb-[15px] md:mb-[40px] leading-[21px] font-bold text-[10px] md:text-[21px] tracking-[0.53px]",
  imgWrapper: "flex flex-wrap lg:pl-[130px] lg:pr-[70px] lg:w-[66.66%] w-100% mb-[50px]",
  imgTxtContainer: "video-box flex flex-wrap flex-row-reverse items-start ndpwithLearnmore justify-end md:justify-between border-b-[1px] border-solid border-[#666666] md:border-none pb-[100px] md:pb-[0px] w-full",
  textHead:
    "text-green text-Ndp_GR xl:text-[60px] xl:mb-[35px] font-Light text-[36px] mb-[20px] max-[767px]:max-w-[357px] [&>p]:max-w-[357px]",
  videoWrapperContainer:'videoWrapperContainer lg:w-[66.66%] w-100% mb-[50px]',
}
export const LEFT_IMG_RIGHT_TEXT = {
  ...RIGHT_IMG_LEFT_TEXT,
  imgWrapper: "flex flex-wrap lg:pr-[70px] lg:w-[66.66%] w-100% mb-[50px]",
  imgTxtContainer: "flex flex-wrap flex-row items-start ndpwithLearnmore justify-between border-b-[1px] border-solid border-[#666666] md:border-none pb-[100px] md:pb-[0px] w-full",
  videoWrapperContainer:'videoWrapperContainer lg:w-[66.66%] w-100% mb-[50px]',
}

export const BOTTOM_TEXT_NO_HEIGHT = {
  ...BOTTOM_TEXT,
  textImg: "w-full block align-middle text-[16px] tracking-normal leading-[24px] overflow-x-clip overflow-y-clip align-left",
}

export const TWO_COL_2_10_WIDTH_WITH_LINKS = {
  ...TWO_COL_10_2_WIDTH_REVERSE_GRAY_WIDTHOUT_BG,
  textWrpr: "smallTextWrpr w-1/2",
}

export const TWO_COL_2_10_WIDTH_WITH_LINKS_WITHOUT_BG = {
  ...TWO_COL_10_2_WIDTH_REVERSE_GRAY_BG,
  textWrpr: "smallTextWrpr w-1/2",
}

export const ONLY_PAGE_IMAGE_CENTER = { 
  ...ONLY_PAGE_IMAGE,
  imgTxtContainer: "flex justify-center md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[35px] lg:px-[15px] mb-[30px] lg:mb-[50px]",
}
export const BOARD_COMMITTES_ICON = { 
  ...defaultStyle,
  imgTxtContainer: "board-comitties text-left max-w-full my-0 mx-auto pr-[40px]",
  textImg: "w-auto",
  imgWrapper: "imgWrapper lg:my-auto mt-0 mb-10",
}

export const FULL_WIDTH_VIDEO = {
  ...RIGHT_IMG_LEFT_TEXT,
  videoWrapperContainer:'videoWrapperContainer lg:max-w-[70%] full-video-center w-auto mb-[50px] mx-auto',
  textWrpr: "text-wrapper",
}

export const SNACKING_MADE_RIGHT_CHART = {
  textDesc: "",
  textWrpr: "",
  textWrpr: "",
  textImg:"",
}
export const LINE_PATTERN1= {
  wrapperFullBg: "bg-[#faf3e7]",
  wrapper: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0 relative",
  imgTxtContainer: "",
  imageWrapper: "",  
  imageWrapperMedium: "absolute right-0 lg:bottom-auto lg:top-[-140px] top-[-280px] z-10",
  imageWrapperLarge: "absolute top-[-130px] lg:top-[-175px] left-[-60px] lg:left-[-35px]",
}
export const LINE_PATTERN2= {
  wrapperFullBg: "bg-[#FDC583]",
  wrapper: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  imgTxtContainer: "",
}
export const LINE_PATTERN3= {
  wrapperFullBg: "bg-[#B5BF5E]",
  wrapper: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0 relative",
  imgTxtContainer: "",
  imageWrapperMedium: "absolute right-0 lg:bottom-auto lg:top-[-140px] top-[-280px] z-10",
  imageWrapperLarge: "absolute top-[-110px] left-[-45px] z-20",
}
export const LINE_PATTERN4= {
  wrapperFullBg: "",
  wrapper: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  imgTxtContainer: "",
}
export const LINE_PATTERN5= {
  wrapperFullBg: "bg-[#D4B7EC]",
  wrapper: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  imgTxtContainer: "",
}
export const LINE_PATTERN6= {
  wrapperFullBg: "bg-[#faf3e7]",
  wrapper: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0 relative test2",
  imgTxtContainer: "",
  imageWrapper: "",
  imageWrapperMedium: "absolute right-0 lg:bottom-auto lg:top-[-140px] top-[-280px] z-10",
  imageWrapperLarge: "absolute top-[-110px] lg:top-[-90px] right-0 lg:right-[-30px]",
}
export const LINE_PATTERN7= {
  wrapperFullBg: "bg-[#B5BF5E]",
  wrapper: "lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0 relative test",
  imgTxtContainer: "",
  imageWrapperMedium: "absolute right-0 lg:bottom-auto lg:top-[-140px] top-[-280px] z-10",
  imageWrapperLarge: "absolute lg:right-[-30px] xl:right-[-90px] top-[-140px] z-20 hidden lg:block",
}
export const COCOA_FARMING_TWO_COLUMN = {
  wrapperFullBg: "bg-[#FDC583] pb-[48px]",
  wrapper:"lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  imgTxtContainer: "flex flex-wrap justify-between relative",
  imgWrapper: "w-full xl:w-[38%] col-left",
  textWrpr: "w-full xl:w-[58.5%] col-right static xl:relative top-[25px]",
  textHead:"font-MDLZBiteType text-[48px] leading-[57.6px] text-DarkPurple mb-16",
  textDesc: "text-20 leading-[24px] text-black font-BwSurco tracking-normal [&>h3]:font-MDLZBiteType [&>h3]:text-[48px] [&>h3]:leading-[57.6px] [&>h3]:text-DarkPurple [&>h3]:mb-16 [&>h3]:mt-[80px]",
}

export const EMPOWERING_LEFT_IMAGE = {
  wrapperFullBg: "bg-[#faf3e7] pt-[40px] pb-[60px]",
  wrapper:"lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  imgTxtContainer: "flex flex-wrap justify-between relative items-center",
  imgWrapper: "w-full lg:w-[48%] col-left",
  textImg: "w-full",
  textWrpr: "w-full lg:w-[48%] col-right",
  textHead:"font-MDLZBiteType text-[48px] leading-[57.6px] text-DarkPurple mb-16",
  textDesc: "text-20 leading-[24px] text-black font-BwSurco tracking-normal [&>h3]:font-MDLZBiteType [&>h3]:text-[48px] [&>h3]:leading-[57.6px] [&>h3]:text-DarkPurple [&>h3]:mb-16 [&>h3]:mt-[80px]",
}

export const EMPOWERING_RIGHT_IMAGE = {
  wrapperFullBg: "bg-[#faf3e7] pt-[40px] pb-[60px]",
  wrapper:"lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  imgTxtContainer: "flex flex-wrap justify-between relative items-center flex-row-reverse",
  imgWrapper: "w-full lg:w-[48%] col-left mb-[48px] xl:mb-0",
  textImg: "w-full",
  textWrpr: "w-full lg:w-[48%] col-right",
  textHead:"font-MDLZBiteType text-[48px] leading-[57.6px] text-DarkPurple mb-16",
  textDesc: "text-20 leading-[24px] text-black font-BwSurco tracking-normal [&>h3]:font-MDLZBiteType [&>h3]:text-[48px] [&>h3]:leading-[57.6px] [&>h3]:text-DarkPurple [&>h3]:mb-16 [&>h3]:mt-[80px]",
}

export const CIRCULAR_FUTURE_LEFT = {
  wrapperFullBg: "bg-[#B5BF5E] py-[40px]",
  wrapper:"lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  imgTxtContainer: "flex flex-wrap justify-between relative items-center",
  imgWrapper: "w-full lg:w-[48%] col-left mb-[48px] lg:mb-0 flex justify-center",
  textWrpr: "w-full lg:w-[48%] col-right",
  textHead:"font-MDLZBiteType text-[48px] leading-[57.6px] text-DarkPurple mb-16",
  textDesc: "text-20 leading-[24px] text-black font-BwSurco tracking-normal [&>h3]:font-bold [&>h3]:text-[26px] [&>h3]:leading-[31.2px] [&>h3]:text-black [&>h3]:mt-[8px] [&>h3]:mb-[24px]",
  imageWrapper: "hidden"
}

export const CIRCULAR_FUTURE_RIGHT = {
  wrapperFullBg: "bg-[#B5BF5E] py-[40px]",
  wrapper:"lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  imgTxtContainer: "flex flex-wrap justify-between relative items-center flex-row-reverse",
  imgWrapper: "w-full lg:w-[48%] col-left mb-[48px] lg:mb-0 flex justify-center",
  textWrpr: "w-full lg:w-[48%] col-right",
  textHead:"font-MDLZBiteType text-[48px] leading-[57.6px] text-DarkPurple mb-16",
  textDesc: "text-20 leading-[24px] text-black font-BwSurco tracking-normal [&>h3]:font-MDLZBiteType [&>h3]:text-[48px] [&>h3]:leading-[57.6px] [&>h3]:text-DarkPurple [&>h3]:mb-16 [&>h3]:mt-[80px]",
  imageWrapper: "hidden"
}

export const CIRCULAR_PROJECT_LEFT = {
  wrapperFullBg: "bg-[#B5BF5E] py-[40px]",
  wrapper:"xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  imgTxtContainer: "flex flex-wrap justify-between relative items-center",
  imgWrapper: "w-full lg:w-[40%] col-left px-0 lg:px-40 flex justify-center lg:justify-start mb-[40px]",
  textWrpr: "w-full lg:w-[60%] col-right",
  textHead:"font-MDLZBiteType text-[48px] leading-[57.6px] text-DarkPurple mb-16",
  textDesc: "text-20 leading-[24px] text-black font-BwSurco tracking-normal [&>h3]:font-BwSurcoBold [&>h3]:text-[32px] [&>h3]:leading-[38.4px] [&>h3]:text-DarkPurple [&>h3]:mb-16",
}

export const CIRCULAR_PROJECT_RIGHT = {
  wrapperFullBg: "bg-[#B5BF5E] pt-80 pb-100 relative z-10",
  wrapper:"xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  imgTxtContainer: "flex flex-wrap justify-between relative items-center flex-row-reverse",
  imgWrapper: "w-full lg:w-[50%] col-left mb-[48px] xl:mb-0",
  textWrpr: "w-full lg:w-[50%] col-right",
  textHead:"font-MDLZBiteType text-[48px] leading-[57.6px] text-DarkPurple mb-16",
  textDesc: "text-20 leading-[24px] text-black font-BwSurco tracking-normal [&>h3]:font-BwSurcoBold [&>h3]:text-[32px] [&>h3]:leading-[38.4px] [&>h3]:text-DarkPurple [&>h3]:mb-16",
}

export const BRANDS_SPEAL_IMAGE_LEFT = {
  wrapperFullBg: "bg-[#D4B7EC] pb-[40px]",
  wrapper:"lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  imgTxtContainer: "flex flex-wrap justify-between relative items-center",
  imgWrapper: "w-full lg:w-[48%] col-left mb-[48px] xl:mb-0",
  textWrpr: "w-full lg:w-[48%] col-right",
  textHead:"",
  textDesc: "text-20 leading-[24px] text-black font-BwSurco tracking-normal [&>p>em]:font-bold",
}

export const BRANDS_SPEAL_IMAGE_RIGHT = {
  wrapperFullBg: "bg-[#D4B7EC] pb-[40px]",
  wrapper:"lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  imgTxtContainer: "flex flex-wrap justify-between relative items-center flex-row-reverse",
  imgWrapper: "w-full lg:w-[48%] col-left mb-[48px] xl:mb-0",
  textWrpr: "w-full lg:w-[48%] col-right",
  textHead:"",
  textDesc: "text-20 leading-[24px] text-black font-BwSurco tracking-normal [&>p>em]:font-bold",
}

export const EMPOWERING_IMG_WITH_TEXT = {
  wrapperFullBg: "bg-[#4F2170] pb-[18px] empowering-img-text",
  wrapper:"lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 xl:px-0",
  imgTxtContainer: "flex flex-wrap justify-between relative items-center flex-col-reverse lg:flex-row-reverse",
  imgWrapper: "w-full lg:w-[38%] col-left",
  textImg: "test",
  textWrpr: "w-full lg:w-[60%] col-right mb-[48px] lg:mb-0",
  textHead:"",
  textDesc: "text-20 leading-[24px] font-BwSurco tracking-normal text-white [&>p]:mb-[32px] [&>h2]:mb-[32px] [&>p>strong]:font-normal"
}

export const INDIA_MAP= {
  wrapperFullBg: "bg-[#D4B7EC] map-footprint relative",
  wrapper: "lg:max-w-lg lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 lg:px-0",
  imgTxtContainer: "",
  textHead:"font-MDLZBiteType text-[60px] leading-[72px] lg:text-[72px] lg:leading-[86.4px] text-purple text-center pt-40 pb-40",
  textDesc: "",
  imageWrapperMedium: "makingcocoatitle imageWrapperLarge absolute right-0 top-[62%] z-10 hidden lg:block w-[27%] xl:w-auto",
  imageWrapperLarge: "makingcocoatitle imageWrapperMedium absolute left-[-90px] lg:left-30 top-[-70px]",
}
export const SUSTAINABILITY_MISSION= {
  wrapperFullBg: "sustainability-mision",
  wrapper:"lg:max-w-lg lg:max-w-lg xl:max-w-[1196px] mx-auto px-20 lg:px-0",
  imgTxtContainer: "flex flex-wrap justify-between relative items-center flex-col-reverse lg:flex-row",
  imgWrapper: "w-full lg:w-[37.5%] col-left",
  textImg: "test",
  textWrpr: "w-full lg:w-[56%] col-right mb-[48px] xl:mb-0 col-right text-[26px] leading-[31.2px] font-BwSurco mb-8 font-bold",
  textHead:"",
  textLinkWrapper: "text-center lg:text-left",
  textLink: "bg-Bisque text-[18px] leading-[27px] font-BwSurcoBold py-[16px] px-[32px] inline-block mx-auto rounded-full mt-[32px] hover:bg-[#D4B7EC] transition delay-100 duration-300 ease-in-out"
}

